import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        root: {
            width: "100%",
        },
        footer: {
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: theme.spacing(4),
            gridGap: theme.spacing(3),
            "& button": {
                width: "180px"
            }
        },
        serviceView: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gridGap: theme.spacing(3),
            marginTop: theme.spacing(2)
        },
        serviceItem: {
            background: theme.palette.background.paper,
            borderRadius: theme.spacing(1),
            padding: theme.spacing(1),
            height: "auto",
            width: "320px",
            cursor: "pointer",
            border: `1px solid transparent`,
            boxShadow: theme.shadows[1],
            "&:hover": {
                "& p": {
                    fontWeight: 500,
                },
                boxShadow: `0px 0px 12px 0px ${theme.palette.blue[7]}`
            },

        },
        imageView: {
            display: "flex",
            alignItems: "center",
            gridGap: theme.spacing(1),
            marginBottom: theme.spacing(0.5),
            "& img": {
                width: theme.spacing(3.5),
                height: theme.spacing(3.5),
                borderRadius: theme.spacing(0.5)
            }
        }
    };
});
